module.exports = __webpack_public_path__ + "ff467f01838a04690a3550fc96a3da9f.MP3";